/**
 * @fileoverview Agent definition for world-set-snapshotter-v3.
 *
 * This agent analyzes a chapter and updates a world set's state,
 * creating a snapshot that reflects any changes from the chapter events.
 *
 * @category world-building.sets.snapshots
 * @type primitive
 */

import type { AppAgentDefinition } from '@/domains/agents/schemas';
import { InputSchema, OutputSchema } from './schema';
import { prompt } from './prompt';

export const definition: AppAgentDefinition = {
  id: 'world-set-snapshotter-v3',
  kind: 'primitive',
  name: 'World Set Snapshotter',
  description: 'Updates a world set state after a chapter, creating a point-in-time snapshot.',
  category: 'world-building',
  defaultPrompt: prompt,
  inputSchema: InputSchema,
  outputSchema: OutputSchema,
  metadata: {
    status: 'active',
    type: 'primitive',
    addedIn: '2026-02',
    taxonomyPath: 'world-building.sets.snapshots',
    usedBy: ['use-world-set-snapshotter-v3.ts'],
    usedInComposites: [],
    relatedAgents: ['world-set-details-generator-v3'],
  },
};
